import { render } from "./PortfolioPage.vue?vue&type=template&id=98526d98&scoped=true"
import script from "./PortfolioPage.vue?vue&type=script&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&lang=js"

import "./PortfolioPage.vue?vue&type=style&index=0&id=98526d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98526d98"]])

export default __exports__